module.exports = __webpack_public_path__ + "img/7.5b23a6db.jpg";